"use client";
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import DDPlayer from "./DDPlayer";
import {Swiper, SwiperSlide} from "swiper/react";

import "swiper/css";
import SwiperNavButtons from "./SwiperNavButtons";
import Image from "next/image";
import Link from "next/link";


const SwipeGallery = ({ options, tuttiIVideo }) => {
  const [currentVideo, setCurrentVideo] = useState(0);
  const [videoOptions, setVideoOptions] = useState(options);
  const videoMedia = (vid) =>
    `https://85f5be9b495b442db3619af2e8f4e008.msvdn.net/vod/${vid}/playlist.m3u8`;
  useEffect(() => {}, [videoOptions]);

  const getPosterPath = (id) => {
    return `/img/ogimages/${id}_poster.jpeg`;
  };
  const thumbClick = (e) => {
    setCurrentVideo(e.target.dataset.index);
    setVideoOptions({
      ...options,
      poster: getPosterPath(e.target.dataset.contentid),
      sources: {
        src: videoMedia(e.target.dataset.contentid),
      },
    });
  };

  return (
    <div className="content" id="videoplayer">
      <div className="media">
        <div className="video">
          <DDPlayer options={videoOptions} />
        </div>
        <div className="videoDescription">
          <h1>{tuttiIVideo.data[currentVideo]?.title}</h1>
          <p>{tuttiIVideo.data[currentVideo]?.shortDescription}</p>
        </div>
      </div>

      <div className="thumbs">
        <Swiper spaceBetween={100} slidesPerView={4}>
          
          {tuttiIVideo.data
            .map((item, ix) => (
              <SwiperSlide key={ix}>
                <Link href="/#videoplayer" onClick={thumbClick}>
                  <div className="thumb">
                    <Image
                      data-contentid={item.contentId}
                      data-index={ix}
                      src={getPosterPath(item.contentId)}
                      alt="movie thumb"
                      fill
                    />
                    <div className="videoTitle">{item.title}</div>
                  </div>
                </Link>
              </SwiperSlide>
            ))
            .reverse()}
          <SwiperSlide />
          <SwiperNavButtons swipeLength={5} />
        </Swiper>
      </div>
    </div>
  );
};

export default SwipeGallery;
